import request from '@/router/axios'

export const getList = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/attendance/attendanceList',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

export const getAttendancePage = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/attendance/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

export const exportExcel = params => request({
  url: '/api/mcc-worker/attendance/clockCardExcel',
  method: 'get',
  responseType: 'blob',
  params,
})

// 考勤修改
export const updateAttendance = params => request({
  url: '/api/mcc-worker/attendance/updateAttendance',
  method: 'post',
  data: params,
})

// 工地主任确认考勤
export const sitedirectCheck = params => request({
  url: '/api/mcc-worker/attendanceprojectsum/sitedirectorConfirmAttendance',
  method: 'post',
  params: {
    ...params,
  },
})

export const workerProjectSumStatus = params => request({
  url: '/api/mcc-worker/attendanceprojectsum/workerProjectSumStatus',
  method: 'get',
  params: {
    ...params,
  },
})
export default {
  getList,
}
